import { findAll } from "../utils/dom";

const ThumbYoutube = () =>{

	const linksYoutube = findAll("[js-link-youtube]");
	if(!linksYoutube) return;

	function getYouTubeThumbnail(url) {
		const videoId = url.split('v=')[1]?.split('&')[0];
		return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
	}
	

	linksYoutube?.forEach((item)=>{
		const link = item.getAttribute("js-link-youtube");
		const thumbUrl = getYouTubeThumbnail(link);

		item.setAttribute("src", thumbUrl);
	})


	
}

export default ThumbYoutube;